import { render, staticRenderFns } from "./chartBar.pug?vue&type=template&id=274467f0&lang=pug&"
import script from "./chartBar.js?vue&type=script&lang=js&"
export * from "./chartBar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274467f0')) {
      api.createRecord('274467f0', component.options)
    } else {
      api.reload('274467f0', component.options)
    }
    module.hot.accept("./chartBar.pug?vue&type=template&id=274467f0&lang=pug&", function () {
      api.rerender('274467f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/charts/components/chartBar/index.vue"
export default component.exports